import React from 'react';
import Dashboard from 'domain/entity/dashboard';
import { useDashboards } from 'adapter/in/dashboards/context/Dashboards';
import { DashboardActionsDropdown } from 'adapter/in/dashboards/components/DashboardActionsDropdown/DashboardActionsDropdown';
import { dispatchAlertToaster } from 'adapter/in/common/context/Alert';
import i18n from 'asset/translation';

export const useDashboardsActionsDropdownColumn = (hasPinnedDashboard = false) => {
    const { getReset } = useDashboards();
    const { setSuccessAlert } = dispatchAlertToaster();

    const onDuplicateModalSuccess = () => {
        setSuccessAlert(i18n.t('dashboards.duplicate.modal.success'));
        getReset();
    };

    const onDeleteModalSuccess = () => {
        setSuccessAlert(i18n.t('dashboards.delete.success'));
        getReset();
    };

    const onPinModalSuccess = (pinned: boolean) => {
        setSuccessAlert(pinned ? i18n.t('dashboards.pinned.modal.unpin.success') : i18n.t('dashboards.pinned.modal.pin.success'));
        getReset();
    };

    return {
        column: {
            title: '',
            dataIndex: '',
            width: 70,
            className: 'background-none remove-border',
            render: (dashboard: Dashboard) => {
                // TODO: Due an issue on render Table, class object seems to be parsed to JSON
                // so it loses its internal functions, so we need to recreate the object to use the copyWith function
                const recreatedDashboard = new Dashboard(
                    dashboard.id,
                    dashboard.name,
                    dashboard.pinned,
                    dashboard.access,
                    dashboard.owner,
                    dashboard.permittedActions,
                    dashboard.starred,
                    dashboard.type
                );
                if (
                    recreatedDashboard.permittedActions.delete ||
                    recreatedDashboard.permittedActions.edit ||
                    recreatedDashboard.permittedActions.link ||
                    recreatedDashboard.permittedActions.share ||
                    recreatedDashboard.permittedActions.pin ||
                    recreatedDashboard.permittedActions.duplicate
                ) {
                    return (
                        <DashboardActionsDropdown
                            dashboard={recreatedDashboard}
                            onDeleteModalSuccess={onDeleteModalSuccess}
                            onShareModalSuccess={() => getReset()}
                            onPinModalSuccess={onPinModalSuccess}
                            onDuplicateModalSuccess={onDuplicateModalSuccess}
                            hasPinnedDashboard={hasPinnedDashboard}
                            withDuplicateRedirection={false}
                        />
                    );
                }
                return <></>;
            },
        },
    };
};
